import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServiceService } from 'src/app/instant-analysis/services/service.service';
import { EventType, Item, ScenegraphEvent } from 'vega';
import { VisualizationSpec } from 'vega-embed';
import { RainCalendar } from '../../models/interfaces/rain-calendar';
import { RainCalendarItem } from '../../models/interfaces/rain-calendar-item';
import { getIntensity, intensityColors, intensityTexts, rainMultipliers } from '../../util/rain-intensity';
import { TimespanService } from 'src/app/instant-analysis/services/timespan/timespan.service';

@Component({
  selector: 'app-interval-rain-calendar',
  templateUrl: './interval-rain-calendar.component.html',
  styleUrls: [
    '../../rain-calendar/rain-calendar.component.css', 
    './interval-rain-calendar.component.css'
  ]
})
export class IntervalRainCalendarComponent extends RainCalendar implements OnInit {

  chartContainerSelector: string = '#interval-calendar-chart-container';

  /** Datas selecionadas no gráfico. */
  selectedDates: Date[] = [];

  /** Indica se os dados do gráfico já foram recebidos ou não. */
  loadedData: boolean = false;

  /** Evento de fechamento do gráfico pelo botão de x */
  @Output() closed = new EventEmitter<boolean>();

  /** */
  @Output() itemClicked = new EventEmitter<RainCalendarItem>();

  /** */
  constructor(
    fb: FormBuilder,
    service: ServiceService,
    snackBar: MatSnackBar,
    timespanService: TimespanService,
  ) {
    super(fb, service, snackBar, timespanService);
  }
  
  ngOnInit(): void {
    this.initForm();
  }

  /**
   * Trata o click no botão de fechar, emitindo um evento de fechamento do gráfico
   * para o componente pai.
   */
  onCloseClicked() {
    this.closed.emit(true);
  }

  afterCreateChart(): void {
    this.loadedData = true;
  }

  createRainChartSpec(dataPoints: any[]): VisualizationSpec {
    return {
      width: 'container',
      // height: 'container',
      background: 'transparent',
      data: {
        values: dataPoints,
      },
      params: [
        {
          name: 'ponto',
          select: 'point',
        }
      ],
      layer: [
        {
          mark: 'rect',
          encoding: {
            x: {
              field: 'tempo',
              timeUnit: 'date',
              type: 'ordinal',
              title: 'Dia',
            },
            y: {
              field: 'tempo',
              timeUnit: 'month',
              type: 'ordinal',
              title: 'Mês',
            },
            color: {
              field: 'intensity',
              type: 'nominal',
              legend: {
                title: 'Chuva'
              },
              scale: {
                domain: intensityTexts,
                range: intensityColors,
              }
            },
            tooltip: [
              { field: 'tempo', type: 'temporal', title: 'Data', timeUnit: 'yearmonthdatehoursminutes' },
              { field: 'max_val', type: 'quantitative', title: 'Chuva' },
              { field: 'intensity', type: 'nominal', title: 'Intensidade' },
            ],
            opacity: {
              condition: {
                param: 'ponto',
                value: 1,
              },
              value: 0.2,
            },
          },
        },
      ],
    };
  }

  createEventChartSpec(dataPoints: any[],eventType:string): VisualizationSpec {
    return {
      width: 'container',
      // height: 'container',
      background: 'transparent',
      data: {
        values: dataPoints,
      },
      params: [
        {
          name: 'ponto',
          select: 'point',
        }
      ],
      layer: [
        {
          mark: 'rect',
          encoding: {
            x: {
              field: 'tempo',
              timeUnit: 'date',
              type: 'ordinal',
              title: 'Dia',
            },
            y: {
              field: 'tempo',
              timeUnit: 'month',
              type: 'ordinal',
              title: 'Mês',
            },
            color: {
              field: eventType,
              type: 'quantitative',
              legend: {
                title: 'ocorrencia'
              },
              scale: {
                scheme: 'browns',
                type:'log',
              }
            },
            tooltip: [
              { field: 'tempo', type: 'temporal', title: 'Data', timeUnit: 'yearmonthdatehoursminutes' },
              { field: 'todos', type: 'quantitative', title: 'ocorrencia' },
              { field: 'alagamento', type: 'quantitative', title: 'alagamento' },
              { field: 'deslizamento', type: 'quantitative', title: 'deslizamento' },
              // { field: 'intensity', type: 'nominal', title: 'Intensidade' },
            ],
            opacity: {
              condition: {
                param: 'ponto',
                value: 1,
              },
              value: 0.2,
            },
          },
        },
      ],
    };
  }

  /**
   * 
   * @param event 
   * @param item 
   */
  onItemClicked(event: ScenegraphEvent, item: Item<any>): void {
    let datesArr = (event.shiftKey == false) ? [] : this.selectedDates;
    let date = new Date(item.datum.tempo);
    datesArr.push(date);
    datesArr.sort((a, b) => a.valueOf() - b.valueOf());

    this.selectedDates = (datesArr.length > 1) ? 
      [datesArr[0], datesArr[datesArr.length - 1]] : datesArr;
  }

  /**
   * Trata o click no botão de pesquisar, emitindo um evento com o intervalo de datas
   * e a coluna do acumulado de chuva selecionados.
   */
  onSearchDateClicked() {

    let { aggregateCol } = this.dateIntervalForm.value;
    let val: RainCalendarItem = {
      aggregateCol,
      dates: this.selectedDates,
    };
    this.itemClicked.emit(val);
  }
}
